import {DialogShell} from "./DialogShell";
import {i18n} from "../../../shared/i18n";


export const OneTimeCredentialDialog = ({credential, onClose}) => (
    <DialogShell open={Boolean(credential)} title={credential?.title || i18n.t("sections.deployers.p65")} entity={i18n.t("sections.deployers.p66")} onClose={onClose}>
        {credential ? (
            <>
                <dl className="deployer-credential">
                    <div><dt>{i18n.t("sections.deployers.p10")}</dt><dd>{credential.username}</dd></div>
                    <div><dt>{i18n.t("sections.deployers.p67")}</dt><dd>{credential.password}</dd></div>
                </dl>
                <footer className="deployer-dialog-footer">
                    <button type="button" className="admin-button admin-button-primary" onClick={onClose}>{i18n.t("sections.deployers.p63")}</button>
                </footer>
            </>
        ) : null}
    </DialogShell>
);
